/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VALIDATE_DISCOUNT } from "../graphql/validateDiscount.mutation";
import { VApplication } from "../../../application";
import { StorageModule } from "@vlinder-web/storage-module-react";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IValidateDiscountMethods extends IPluginMethodMap {
    validateDiscount(args: any): Promise<any>;
}

export class ValidateDiscountService implements IAgentPlugin {
    readonly methods: IValidateDiscountMethods;

    constructor() {
        this.methods = {
            validateDiscount: this.validateDiscount.bind(this),
        };
    }

    async validateDiscount(args: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            // return {...config}
            console.log("args43", args)
            let filter = {
                ...(args?.discount && { couponCode: args?.discount }),
                ...(args?.presentation && { presentation: args?.presentation }),
                ...(args?.section && { section: args?.section }),
                ...(args?.sectionOptType && { sectionOptType: args?.sectionOptType }),
            };
            if (client) {
                const res = await client.mutate({
                    mutation: VALIDATE_DISCOUNT,
                    variables: {
                        data: {
                            discountCode: args?.discount
                        }
                    },
                    fetchPolicy: "no-cache",
                });
                console.log(res);
                if (res?.data) {
                    return {
                        ...res?.data,
                    };
                }
            }
        } catch (err: any) {
            let _display_message =
                err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.find((item: any) => item.extensions);
            console.log("hi")
            if (_display_message?.extensions?.display_message) {
                throw Error(_display_message?.extensions?.display_message);
            }

            throw err;
        }
    }

}
